import { useSTKContext } from '@/context/context';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { Freeze } from '../../types/freeze.types';
import { Group } from '../../types/groups.types';

export const useStoreBundleGroups = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<Group[]>>({
    queryKey: ['store-groups'],
    queryFn: () => apiClient.get<Group[]>(`/bundle-groups`),
    enabled,
  });
};

export const useActiveFreezes = (enabled: boolean) => {
  const { apiClient } = useSTKContext();
  return useQuery<AxiosResponse<Freeze[]>>({
    queryKey: ['freezes'],
    queryFn: () => apiClient.get<Freeze[]>(`/freezes/current`),
    enabled,
  });
};

export const useDeleteStoreGroup = (groupId: string) => {
  const { apiClient } = useSTKContext();
  return useMutation({
    mutationFn: () => apiClient.delete(`/bundle-groups/${groupId}`),
  });
};

export const useCreateStoreGroup = () => {
  const { apiClient } = useSTKContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newGroup: { name: string; stores: string[]; templateGroupId: string }) =>
      apiClient.post('/bundle-groups', newGroup),
    onSuccess: () => {
      queryClient.invalidateQueries(['store-groups']);
      queryClient.invalidateQueries(['national-programs']);
      queryClient.removeQueries(['national-programs']);
    },
  });
};

export const useUpdateGroup = (groupId: string | undefined) => {
  const { apiClient } = useSTKContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (updatedGroup: { name?: string; stores?: string[]; groupIdToDelete?: string }) =>
      apiClient.put(`/bundle-groups/${groupId}`, updatedGroup),
    onSuccess: () => {
      queryClient.invalidateQueries(['store-groups']);
    },
  });
};
export const useUpdateGroupName = () => {
  const { apiClient } = useSTKContext();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (mutationInput: { newName: string; groupId: string }) =>
      apiClient.put(`/bundle-groups/${mutationInput.groupId}/${mutationInput.newName}`),
    onSuccess: () => {
      queryClient.invalidateQueries(['store-groups']);
    },
  });
};
